import { useContext } from 'react'
import { ContestantScoreContext } from '../context/ContestantScoreContext'

export default function useContestantScore() {
    const context = useContext(ContestantScoreContext)

    if (context === undefined) {
        throw new Error('useContestantScore must be used within a ContestantScoreProvider')
    }

    return context
}
